/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ConfigService} from './config.service';

@Injectable({
  providedIn: 'root'
})
export class SubregionService {
  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }


  /**
   * Gets all subregions
   */
  getSubregions(): Observable<any> {

    return this.http.get<any>(`${this.configService.baseApiUrl}subregions`,)
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Gets the distinct subregions filtered by region and industry scenario id
   *
   * @param region    The filtering region
   * @param indScenId The scenario ID to use
   * @param gmid The user's GMID
   */
  getSubregionsByRegionAndIndScenId(region: string, indScenId: number, gmid: string): Observable<any> {
    const params = new HttpParams().set('region', region).set('ind-scen-id', indScenId).set('gmid', gmid);

    return this.http.get<any>(`${this.configService.baseApiUrl}subregions`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Gets the distinct subregions the user can access filtered by vehicle scenario id
   * @param vehScenId The id of the associated vehicle scenario
   * @param gmid The users GMID
   */
  getSubregionsByVehicleScenario(vehScenId: number, gmid: string): Observable<any> {
    const params = new HttpParams().set('veh-scen-id', vehScenId).set('gmid', gmid);

    return this.http.get<any>(`${this.configService.baseApiUrl}subregions`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Adds a new subregion
   * @param subregion The subregion to add
   * @param region The region to add the subregion to
   */
  addSubregion(subregion: string, region: string): Observable<any> {
    const headers = new HttpHeaders();
    const payload = {
      subregion: subregion,
      region: region
    }
    headers.set('Content-Type', 'application/json');
    return this.http.post<any>(`${this.configService.baseApiUrl}subregions`, payload, {headers}).pipe(
      catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   */
  private handleError(errorResponse: HttpErrorResponse): Observable<any> {
    let errorMessage = 'An unexpected error has occurred.';
    if (errorResponse.error && errorResponse.error.message) {
      errorMessage = errorResponse.error.message;
    }
    return throwError(errorMessage);
  }
}
